import React from 'react';
import TaskStatusBadge from './TaskStatusBadge';
import TaskPriorityBadge from './TaskPriorityBadge';
import DueIndicator from '../DueIndicator';
import { formatDateShort } from '../../utils/dateFormat';
import { dueStatus } from '../../utils/dueStatus';

export default function TaskCard({ task, onClick, compact }) {
  const due = dueStatus(task.due_date, task.status);
  const isOverdue = due === 'overdue';
  const isDueSoon = due === 'due_soon';

  return (
    <div
      onClick={onClick}
      className={`bg-white dark:bg-gray-800 border rounded-lg cursor-pointer hover:shadow-md transition-shadow
        ${isOverdue ? 'border-red-300 dark:border-red-700' : isDueSoon ? 'border-amber-300 dark:border-amber-700' : 'border-gray-200 dark:border-gray-700'}
        ${compact ? 'p-2' : 'p-3'}`}
    >
      <div className="flex items-start justify-between gap-2 mb-1">
        <h4 className={`font-medium text-gray-800 dark:text-gray-200 line-clamp-2 flex items-center gap-1.5 ${compact ? 'text-xs' : 'text-sm'}`}>
          <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: task.team_color || '#3B82F6' }} />
          {task.title}
        </h4>
        <TaskPriorityBadge priority={task.priority} />
      </div>

      <div className="flex items-center gap-2 flex-wrap mt-2">
        <TaskStatusBadge status={task.status} />

        {(task.start_date || task.due_date) && (
          <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
            {task.start_date && (
              <span><span className="text-gray-400 dark:text-gray-500">Start</span> {formatDateShort(task.start_date)}</span>
            )}
            {task.start_date && task.due_date && <span className="text-gray-300 dark:text-gray-600">→</span>}
            {task.due_date && (
              <span className={`inline-flex items-center gap-1 ${isOverdue ? 'text-red-600 dark:text-red-400 font-semibold' : isDueSoon ? 'text-amber-600 dark:text-amber-400 font-semibold' : ''}`}>
                <DueIndicator state={due} />
                <span className={`${isOverdue || isDueSoon ? '' : 'text-gray-400 dark:text-gray-500'}`}>Due</span> {formatDateShort(task.due_date)}
              </span>
            )}
          </div>
        )}
      </div>

      {!compact && task.assignees && task.assignees.length > 0 && (
        <div className="mt-2 flex items-center gap-1 flex-wrap">
          {task.assignees.slice(0, 3).map((a, i) => (
            <span key={i} className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 text-xs font-bold" title={a.display_name}>
              {a.display_name?.charAt(0)?.toUpperCase() || '?'}
            </span>
          ))}
          {task.assignees.length > 3 && (
            <span className="text-xs text-gray-500 dark:text-gray-400">+{task.assignees.length - 3}</span>
          )}
        </div>
      )}

      {!compact && (task.comment_count > 0 || task.file_count > 0) && (
        <div className="mt-2 flex items-center gap-3 text-xs text-gray-400 dark:text-gray-500">
          {task.comment_count > 0 && <span>💬 {task.comment_count}</span>}
          {task.file_count > 0 && <span>📎 {task.file_count}</span>}
        </div>
      )}
    </div>
  );
}
